export default "__VITE_ASSET__Db4M8tmy__";